import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDebouncedCallback } from 'use-debounce'

import TextInput from '../../../../../../App/Components/Form/TextInput/TextInput'
import { useAppDispatch } from '../../../../../../App/Hooks/reduxHooks'
import { updateSurveyTrigger } from '../../../../Store/Action'
import { DescriptionCardState } from '../EditDescriptionCard'

import { FrequencyDropDown } from './FrequencyDropDown'

type Props = {
  descriptionCardState: DescriptionCardState
  setDescriptionCardState: (arg: DescriptionCardState) => void
  surveyId: string
}

export const TriggerBefore: React.FC<Props> = ({
  descriptionCardState,
  setDescriptionCardState,
  surveyId,
}) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const onChangeAmount = (newAmount: string) => {
    if (
      !descriptionCardState.trigger ||
      descriptionCardState.trigger.type !== 'send_days_before_appointment'
    ) {
      return
    }

    const checkAmount = parseInt(newAmount, 10)

    setDescriptionCardState({
      ...descriptionCardState,
      currentState: 'loading',
      trigger: {
        ...descriptionCardState.trigger,
        amount: checkAmount,
      },
    })

    dispatch(
      updateSurveyTrigger(surveyId, {
        ...descriptionCardState.trigger,
        amount: checkAmount,
      }),
    ).then(() =>
      setDescriptionCardState({
        ...descriptionCardState,
        currentState: 'idle',
      }),
    )
  }

  const debouncedUpdate = useDebouncedCallback(
    (value: string) => onChangeAmount(value),
    300,
  )

  if (descriptionCardState.trigger?.type !== 'send_days_before_appointment') {
    return null
  }

  return (
    <div style={{ marginLeft: '8px' }}>
      <FrequencyDropDown
        setDescriptionCardState={setDescriptionCardState}
        descriptionCardState={descriptionCardState}
        surveyId={surveyId}
      />
      <TextInput
        defaultValue={
          descriptionCardState.trigger?.amount
            ? descriptionCardState.trigger?.amount
            : '1'
        }
        isRequired
        label={t('Amount of days before the appointment')}
        onChange={event => debouncedUpdate(event.target.value)}
        inputStyle="line"
        error={null}
        type="number"
        min="1"
      />
    </div>
  )
}
